var _path, _ellipse, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 55,
    viewBox: "0 0 148 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5121 0L15.7979 15.0217L34.8567 54.1693H51.6466L23.5121 0Z",
    fill: "#43583C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.99131,
    cy: 45.9754,
    rx: 8.16807,
    ry: 8.19367,
    fill: "#BCB0A2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.6465,
    y: 9.16943,
    width: 1,
    height: 45,
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.929 54.1692C140.765 54.1692 147.929 46.9833 147.929 38.119C147.929 29.2547 140.765 22.0688 131.929 22.0688C123.092 22.0688 115.929 29.2547 115.929 38.119C115.929 46.9833 123.092 54.1692 131.929 54.1692Z",
    fill: "#43583C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.383 38.119H96.6362L102.609 43.8726C101.051 45.4973 98.8954 46.4183 96.6362 46.4183C92.0972 46.4183 88.3628 42.6722 88.3628 38.119C88.3628 33.5658 92.0972 29.8197 96.6362 29.8197C99.9269 29.8197 102.795 31.7962 104.115 34.6213H112.234C110.645 27.4396 104.28 22.0688 96.6465 22.0688C87.8057 22.0688 80.6465 29.2505 80.6465 38.119C80.6465 46.9875 87.8057 54.1692 96.6465 54.1692C105.487 54.1692 112.646 46.9875 112.646 38.119H103.393H103.383Z",
    fill: "#43583C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimple);
export default __webpack_public_path__ + "static/media/logo_simple.318eb35c5f3b7306d4ccd3e64beca08a.svg";
export { ForwardRef as ReactComponent };